<script lang="ts"> 
    import FeatherIcon from "svelte-feather-icon";
    import { Col } from "sveltestrap";
    import { LatestUpdates, SeeAll } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import {latestData} from "../../../Data/FAQ/FAQ"
</script>
<Col lg="12">
    <Card cardHeaderprops="faq-header" cardBodyprops="faq-body"> 
      <div slot="customheader">
        <h5 class="d-inline-block ps-0">{LatestUpdates}</h5>
        <span class="pull-right d-inline-block">{SeeAll}</span>
      </div>
      <div slot="contentbody">
        {#each latestData as faqItem}
            <div class="media updates-faq-main">
                <div class="updates-faq">
                    <FeatherIcon class="font-primary" icon={faqItem.icon} />
                </div>
                <div class="media-body updates-bottom-time">
                    <p>{faqItem.paragraph}</p>
                    <p>{faqItem.time}</p>
                </div>
            </div>
        {/each}
      </div>
    </Card>
</Col>